import apiClient from "./apiClient";
const ricetteAPI = {
    // getAllMezzi: () => apiClient.get(`/mezzi/index?company_id=${localStorage.getItem('company_id')}&cantina_id=${localStorage.getItem('cantine_id')}`),
    getAllRicette: () => apiClient.get(`/ricette/index?company_id=${localStorage.getItem('company_id')}`),
    createRicette: (data) => apiClient.post(`/ricette/store?company_id=${localStorage.getItem('company_id')}`, data),
    //Enum
    getTipo: () => apiClient.get(`/ricette/get-tipo`),
};
export default ricetteAPI;